import {UnsubscribeBaseModel} from "../../base/model/UnsubscribeBase.model";
import {Injectable} from "@angular/core";
import {AppData} from "../AppData";
import { HttpClient } from "@angular/common/http";
import {CompoApp} from "../CompoApp";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {take} from "rxjs/operators";
import {DynamicFilterRequestDto} from "../../models/dynamic-filter/dynamic-filter-request-dto.model";
import {MultiObjectRentalModel} from "../../models/component/multi-object-rental.model";

@Injectable()
export class MultiObjectRentalRequestService extends UnsubscribeBaseModel {
  private data: AppData;

  constructor(
    private http: HttpClient,
    private app: CompoApp
  ) {
    super();
    this.data = app.data;
  }

  fetchMultiObjectFutureRentals(dto: DynamicFilterRequestDto, offset: number = 0, size: number = 50, isLending: boolean) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.getFutureRentals)
      .param('offset', offset)
      .param('size', size)
      .param('accessMode', this.data.getAccessMode())
      .param('isLending', isLending)
      .build();
    return this.http.post<any>(url, dto).pipe(take(1));
  }

  fetchMultiObjectHistoryRentals(dto: DynamicFilterRequestDto, offset: number = 0, size: number = 50 ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.getHistoryRentals)
      .param('offset', offset)
      .param('size', size)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.post<any>(url, dto).pipe(take(1));
  }

  fetchMultiObjectCurrentRentals(dto: DynamicFilterRequestDto, offset: number = 0, size: number = 50, isLending: boolean ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.getCurrentRentals)
      .param('offset', offset)
      .param('size', size)
      .param('accessMode', this.data.getAccessMode())
      .param('isLending', isLending)
      .build();
    return this.http.post<any>(url, dto).pipe(take(1));
  }



  createRental(dto: MultiObjectRentalModel ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.createRental)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.post<any>(url, dto).pipe(take(1));
  }

  updateRental(dto: MultiObjectRentalModel) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.updateRental)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.put<any>(url, dto).pipe(take(1));
  }

  confirmMultiObjectRental(rentalId: string ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.confirmRental)
      .param('rentalId', rentalId)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.put<any>(url, {}).pipe(take(1));
  }


  returnMultiObjectRental(rentalId: string ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.returnRental)
      .param('rentalId', rentalId)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.put<any>(url, {}).pipe(take(1));
  }

  returnMultiObject(rentalId: string, multiObjectId: string) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.returnObject)
      .param('rentalId', rentalId)
      .param('multiObjectId', multiObjectId)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.put<any>(url, {}).pipe(take(1));
  }

  deleteMultiObjectRental(rentalId: string ) {
    const url = new UrlBuilder(Constants.URLS.objects.multiObjectRental.deleteRental)
      .param('rentalId', rentalId)
      .param('accessMode', this.data.getAccessMode())
      .build();
    return this.http.delete<any>(url, {}).pipe(take(1));
  }

}
